import {bankLists} from "@/config/banksList";
import type {PagoMovilAccount, PagoMovilAccountApi, PagoMovilAccountsApiResponse} from "./pagoMovilAccounts.types";

interface LegacyBank {
  bank_code: string;
  bank_name: string;
}

const BANK_MAP = new Map<string, string>(
  (bankLists as LegacyBank[]).map(b => [String(Number(b.bank_code)), b.bank_name])
);

export const findBankName = (bankCode: number | string): string => {
  const key = String(Number(bankCode));
  return BANK_MAP.get(key) ?? `Banco ${bankCode}`;
};

const adaptAccount = (api: PagoMovilAccountApi): PagoMovilAccount => ({
  id: String(api.ID),
  bankCode: String(api.bank_code).padStart(4, "0"),
  bankName: findBankName(api.bank_code),
  phoneNumber: String(api.phone_number),
});

export const adaptPagoMovilAccounts = (response: PagoMovilAccountsApiResponse): PagoMovilAccount[] => {
  const list = response?.data?.data;
  if (!Array.isArray(list)) return [];
  return list.map(adaptAccount);
};
